import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ButtonToolbar, ButtonGroup, Badge, MenuItem, DropdownButton } from 'react-bootstrap';
import { GROUP_COLORS, EVENT_COLORS } from './EventStyles';

import EventIcon from './EventIcon';

function formatEventName(eventType) {
  let event = '';
  switch(eventType){
    case 'show':
      event = 'Event Day';
      break;

    case 'stay':
      event = 'Hotel';
      break;

    case 'off':
      event = 'Off Day';
      break;

    case 'trav':
      event = 'Travel Day';
      break;

    case 'prep':
      event = ' Prep/Rehearsal/Practice Day';
      break;

    default:
      event = ''
  }
  return event;
}
function formatButton(buttons, filterType, filter, setFilter) {
  const isSet = filter[filterType] === true;
  const indicator = isSet ? (
    <i className="fa fa-square-o" aria-hidden="true" />
  ) : (
    <i className="fa fa-check-square-o" aria-hidden="true" />
  );
  const style = { color: EVENT_COLORS[filterType] };
  const colorSwatch = <i className="fa fa-square fa-stack-2x" aria-hidden="true" style={style} />;
  buttons.push(
    <MenuItem key={filterType} onClick={setFilter} data-item={filterType} data-value={isSet}>
      {indicator}
      <EventIcon eventType={filterType} size="sm" />{' '}
      <span className="sm colorswatch-span-icon" aria-hidden="true">
        {colorSwatch}
        <p id='eventFilterIconTypes'>{formatEventName(filterType)}</p>
      </span>
    </MenuItem>
  );
}
function formatButtonGroup(buttons, group, groupName, filter, setFilter) {
  const isSet = filter[groupName] === true;
  const indicator = isSet ? (
    <i className="fa fa-square-o" aria-hidden="true" />
  ) : (
    <i className="fa fa-check-square-o" aria-hidden="true" />
  );
  const style = { color: GROUP_COLORS[group % 4] };
  const colorSwatch = <i className="fa fa-square fa-2x vertical-align-middle" aria-hidden="true" style={style} />;

  buttons.push(
    <MenuItem key={groupName} onClick={setFilter} data-item={groupName} data-value={isSet}>
      {indicator} {groupName} {colorSwatch}
    </MenuItem>
  );
}

const FILTER_TYPES = ['show', 'stay', 'off', 'trav', 'prep'];

class EventFilterToolbar extends Component {
  constructor(props) {
    super(props);
    this.setFilter = this.setFilter.bind(this);
  }
  setFilter = e => {
    const filterType = e.currentTarget.getAttribute('data-item');
    const filterValue = e.currentTarget.getAttribute('data-value') === 'true';
    const newFilter = {};
    // TOGGLE the filter values
    newFilter[filterType] = !filterValue;
    this.props.eventFilterSet(newFilter);
  };

  render() {
    try {
      const buttons = [];
      const groupButtons = [];
      // const count = Object.keys(this.props.filter).length;
      let count = (Object.values(this.props.filter)).filter(value => value === true).length;
      let title = (
        <span>
          Filter<Badge>{count}</Badge>
        </span>
      );
      if (count === 0) {
        title = <span>Filter</span>;
      }
      FILTER_TYPES.forEach(filterType => {
        formatButton(buttons, filterType, this.props.filter, this.setFilter);
      });

      this.props.groups.forEach(group => {
        formatButtonGroup(groupButtons, group.id, group.name, this.props.filter, this.setFilter);
      });
      return (
        <ButtonToolbar>
          <ButtonGroup className="event-type-dropdown-btn">
            <DropdownButton title={title} id="bg-nested-dropdown">
              {buttons}
              <MenuItem divider />
              {groupButtons}
            </DropdownButton>
          </ButtonGroup>
        </ButtonToolbar>
      );
    } catch (e) {
      return null;
    }
  }
}
EventFilterToolbar.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.object).isRequired,
  filter: PropTypes.object,
  eventFilterSet: PropTypes.func.isRequired,
};
EventFilterToolbar.defaultProps = {
  filter: {},
  groups: [],
};

export default EventFilterToolbar;



// WEBPACK FOOTER //
// src/routes/tours/components/EventFilterToolbar.js